// @ts-strict-ignore
import type { Module } from 'vuex'

import type { SearchState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'

import { BrowseAction } from './actions/browse.action'
import { SearchAction } from './actions/search.action'
import { SEARCH_CONSTS } from './search.consts'

export const SEARCH_MODULE: Module<SearchState, any> = {
  namespaced: true,

  initialState: (): SearchState => ({}),
  state: (): SearchState => SEARCH_MODULE.initialState(),

  getters: {},

  actions: {
    [SEARCH_CONSTS.actions.search]: SearchAction.execute,
    [SEARCH_CONSTS.actions.browse]: BrowseAction.execute,
    [SEARCH_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, SEARCH_MODULE.initialState()),
  },

  mutations: {
    [SEARCH_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
